// extracted by mini-css-extract-plugin
export default {"subscription_item_price":"tw","delete_item":"uw","subscription_item":"vw","subscription_item_img_wrapper":"ww","subscription_item_info":"xw","subscription_item_title":"yw","subscription_item_edit":"zw","subscription_item_wrapper":"Aw","arrow":"Bw","subscription_item_category":"Cw","plus_button":"Ew","more_details":"Fw","old_price":"Gw","discount":"Hw"};
    if(module.hot) {
      // 1713912565617
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  